/**
 * @generated SignedSource<<9217ce1967fc3d7121c319a2f3112150>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TemplateVisibility = "GLOBAL" | "HIDDEN" | "USER" | "WORKSPACE";
export type noteTemplateGqlCreateNoteTemplateMutation$variables = {
  parentId?: string | null;
  rawDraftJson: any;
  schemaVersion: number;
  summary: string;
  tags: ReadonlyArray<string>;
  title: string;
  visibility: TemplateVisibility;
};
export type noteTemplateGqlCreateNoteTemplateMutation$data = {
  readonly createNoteTemplate: {
    readonly templateEdge: {
      readonly node: {
        readonly author: {
          readonly fullName?: string;
          readonly iconName?: string | null;
          readonly name?: string;
        } | null;
        readonly id: string;
        readonly starred: boolean;
        readonly summary: string;
        readonly tags: ReadonlyArray<string>;
        readonly title: string;
        readonly updatedAt: string;
        readonly viewerAppliedAt: string | null;
        readonly visibility: TemplateVisibility;
        readonly " $fragmentSpreads": FragmentRefs<"GridNoteTemplates">;
      };
    };
  } | null;
};
export type noteTemplateGqlCreateNoteTemplateMutation = {
  response: noteTemplateGqlCreateNoteTemplateMutation$data;
  variables: noteTemplateGqlCreateNoteTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "parentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rawDraftJson"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "schemaVersion"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "summary"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tags"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "visibility"
},
v7 = [
  {
    "kind": "Variable",
    "name": "parentId",
    "variableName": "parentId"
  },
  {
    "kind": "Variable",
    "name": "rawDraftJson",
    "variableName": "rawDraftJson"
  },
  {
    "kind": "Variable",
    "name": "schemaVersion",
    "variableName": "schemaVersion"
  },
  {
    "kind": "Variable",
    "name": "summary",
    "variableName": "summary"
  },
  {
    "kind": "Variable",
    "name": "tags",
    "variableName": "tags"
  },
  {
    "kind": "Variable",
    "name": "title",
    "variableName": "title"
  },
  {
    "kind": "Variable",
    "name": "visibility",
    "variableName": "visibility"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "starred",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerAppliedAt",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v17 = [
  (v16/*: any*/)
],
v18 = {
  "alias": "iconName",
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logo",
  "storageKey": null
},
v22 = [
  (v16/*: any*/),
  (v21/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "noteTemplateGqlCreateNoteTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "CreateNoteTemplate",
        "kind": "LinkedField",
        "name": "createNoteTemplate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteTemplateEdge",
            "kind": "LinkedField",
            "name": "templateEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteTemplateNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": (v17/*: any*/),
                        "type": "TemplateUserAuthor",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v17/*: any*/),
                        "type": "TemplateCompanyAuthor",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v18/*: any*/)
                        ],
                        "type": "TemplateIconAuthor",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v17/*: any*/),
                        "type": "Account",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v17/*: any*/),
                        "type": "ExternalAccount",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v19/*: any*/)
                        ],
                        "type": "User",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "GridNoteTemplates"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "noteTemplateGqlCreateNoteTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "CreateNoteTemplate",
        "kind": "LinkedField",
        "name": "createNoteTemplate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteTemplateEdge",
            "kind": "LinkedField",
            "name": "templateEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteTemplateNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v16/*: any*/),
                          (v20/*: any*/),
                          {
                            "alias": "fullName",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          }
                        ],
                        "type": "TemplateUserAuthor",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v16/*: any*/),
                          (v21/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "darkModeLogo",
                            "storageKey": null
                          }
                        ],
                        "type": "TemplateCompanyAuthor",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "icon",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "color",
                            "storageKey": null
                          },
                          {
                            "alias": "nameThatIsOptional",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          }
                        ],
                        "type": "TemplateIconAuthor",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v22/*: any*/),
                        "type": "Account",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v22/*: any*/),
                        "type": "ExternalAccount",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v19/*: any*/),
                          (v8/*: any*/),
                          (v20/*: any*/)
                        ],
                        "type": "User",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v8/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      },
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isNoteTemplateAuthor"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "viewerCanEdit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "appliedCount",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8d1385aa96ad4a9cfd6724b7d8762849",
    "id": null,
    "metadata": {},
    "name": "noteTemplateGqlCreateNoteTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation noteTemplateGqlCreateNoteTemplateMutation(\n  $title: String!\n  $summary: String!\n  $tags: [String!]!\n  $rawDraftJson: JSON!\n  $visibility: TemplateVisibility!\n  $schemaVersion: Int!\n  $parentId: ID\n) {\n  createNoteTemplate(title: $title, summary: $summary, tags: $tags, rawDraftJson: $rawDraftJson, visibility: $visibility, schemaVersion: $schemaVersion, parentId: $parentId) {\n    templateEdge {\n      node {\n        id\n        title\n        starred\n        summary\n        tags\n        updatedAt\n        viewerAppliedAt\n        visibility\n        author {\n          __typename\n          ... on TemplateUserAuthor {\n            name\n          }\n          ... on TemplateCompanyAuthor {\n            name\n          }\n          ... on TemplateIconAuthor {\n            iconName: name\n          }\n          ... on Account {\n            name\n          }\n          ... on ExternalAccount {\n            name\n          }\n          ... on User {\n            fullName\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...GridNoteTemplates\n      }\n    }\n  }\n}\n\nfragment GridElementTemplate on NoteTemplateNode {\n  id\n  viewerCanEdit\n  starred\n  visibility\n  ...TemplateCardFullsizeNoteTemplate\n}\n\nfragment GridNoteTemplates on NoteTemplateNode {\n  id\n  ...GridElementTemplate\n}\n\nfragment StarButtonNoteTemplate on NoteTemplateNode {\n  id\n  starred\n}\n\nfragment TemplateAuthor_Author on NoteTemplateAuthor {\n  __isNoteTemplateAuthor: __typename\n  __typename\n  ... on User {\n    id\n    fullName\n    image\n  }\n  ... on Account {\n    name\n    logo\n  }\n  ... on ExternalAccount {\n    name\n    logo\n  }\n  ... on TemplateUserAuthor {\n    image\n    fullName: name\n  }\n  ... on TemplateCompanyAuthor {\n    name\n    logo\n    darkModeLogo\n  }\n  ... on TemplateIconAuthor {\n    icon\n    color\n    nameThatIsOptional: name\n  }\n}\n\nfragment TemplateCardFullsizeNoteTemplate on NoteTemplateNode {\n  title\n  starred\n  summary\n  appliedCount\n  author {\n    __typename\n    ...TemplateAuthor_Author\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  ...StarButtonNoteTemplate\n}\n"
  }
};
})();

(node as any).hash = "ee0b2a52fc4195fd5507ff14aad1fe8e";

export default node;
